'use client';

import React, { FC } from 'react';
import { TypeNavColumnFields } from '@/core/generated-types';
import { DynamicComponent } from '@/components/common/DynamicComponent';

export const NavColumn: FC<TypeNavColumnFields> = ({
  entryName: _entryName,
  items,
}) => {
  return (
    <div data-testid="nav-column" className="flex flex-col gap-7">
      {items.map((item) => {
        return <DynamicComponent component={item} key={item.sys.id} />;
      })}
    </div>
  );
};

export default React.memo(NavColumn);
